import { SearchWorkflowTemplateTasksResponseTask } from "../../../../models";
import { ServiceError } from "../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../widget";
import { useDeleteTemplateTaskModal } from "./useDeleteTemplateTaskModal";

interface DeleteTemplateTaskModalProps {
  show: boolean;
  closeModal: () => void;
  closePanel: () => void;
  templateTask?: SearchWorkflowTemplateTasksResponseTask;
}

export const DeleteTemplateTaskModal = ({
  show,
  closeModal,
  closePanel,
  templateTask,
}: DeleteTemplateTaskModalProps): JSX.Element => {
  const { handleDeleteTemplateTask, isHandleDeleteTemplateTaskLoading, onCancel, errors } = useDeleteTemplateTaskModal({
    closeModal,
    closePanel,
    templateTask,
  });

  return (
    <Modal show={show} title="Delete task?" onClose={onCancel}>
      {errors && errors.length > 0 && (
        <Row spacingV="ml" justify="center">
          <Column span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleDeleteTemplateTask(e)}>
        <Row spacingV="ll" justify="center">
          <Column span={10}>
            <p className="body1">
              This action cannot be undone. Once deleted, all associated information will be lost.
            </p>
          </Column>
        </Row>
        <Row justify="center">
          <ActionButtons onCancel={onCancel} submitButtonLabel="Yes" isLoading={isHandleDeleteTemplateTaskLoading} />
        </Row>
      </form>
    </Modal>
  );
};
